import { render, staticRenderFns } from "./LearningUnitMethodFieldForm.vue?vue&type=template&id=81dc4212&"
import script from "./LearningUnitMethodFieldForm.vue?vue&type=script&lang=js&"
export * from "./LearningUnitMethodFieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports